<div class="dpmenergy-root"
	role="img">
	<div *ngFor="let filled of items;"
		class="energy"
		[ngClass]="{'filled':filled,'normal':!filled}">
	</div>
</div>
